import BMap from 'BMap'
// import BMAP_ANCHOR_TOP_LEFT from 'BMAP_ANCHOR_TOP_LEFT'
import bus from '../../bus/bus'
import i18n from '../../i18n/i18n'
class OrgFenceControl extends BMap.Control {
  constructor (option) {
    super()
    // 默认停靠位置和偏移量
    // 也可以由传入的参数控制
    this.defaultAnchor = option.anchor || BMAP_ANCHOR_TOP_LEFT
    this.defaultOffset = option.offset || new BMap.Size(20, 20)
    // 自定义参数
    // .....
    this.text = i18n.t('home.showOrgFences')
    this.isShowingFence = false
    this.div = undefined
  }
  setText(){
    this.div.innerHTML = this.computedText()
  }
  computedText () {
    return this.isShowingFence ? i18n.t('home.hideOrgFences') : i18n.t('home.showOrgFences')
  }
  computedEvent () {
    return this.isShowingFence ? 'hideOrgFence' : 'showOrgFence'
  }
  removeHandler () {
    this.div.removeEventListener('click', this.clickFunction)
  }
  initialize (map) {
    const div = document.createElement('div')
    // 添加文字说明
    div.appendChild(document.createTextNode(this.computedText()))
    // 设置样式
    div.style.border = ".5px solid #aaa"
    div.style.fontSize = '12px'
    div.style.backgroundColor = 'rgba(139, 164, 220, .9)'
    div.style.color = 'rgb(255, 255, 255)'
    div.style.padding = '3px 6px'
    div.style.boxShadow = '2px 2px 3px rgba(0, 0, 0, 0.35)'
    div.style.cursor = "pointer"
    this.div = div
    // div.s
    const clickFunction = () => {
      console.log('emit')
      bus.$emit(this.computedEvent())
      // console.log(div.childNodes)
      this.isShowingFence = !this.isShowingFence
      this.div.innerText = this.computedText()
    }
    this.clickFunction = clickFunction
    // this.div.removeEventListener('click', this.clickFunction)
    this.div.addEventListener('click', this.clickFunction)
    // div.onclick = clickFunction
    // console.log(div)
    // 添加DOM元素到地图中
    map.getContainer().appendChild(div)
    // 将DOM元素返回
    return this.div
  }
}

export default OrgFenceControl